import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  label: {
    minWidth: 'auto',
    maxWidth: 'inherit',
    padding: 0,
    fontWeight: 500,
    fontSize: 13,
  },
  title: {
    flexGrow: 1,
    fontSize: 14,
    margin: theme.spacing(1),
  },
  gridPaper: {
    height: '100%',
  },
  card: {
    position: 'relative',
    borderRadius: '18px',
    padding: '10px',
    height: '180px',
    cursor: 'default',
    transition: '0.3s',
    border: '1px solid #e5e7eb',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
  },
  approvedCard: {
    borderTop: '4px solid #22c55e',
  },
  deniedIcon: {
    color: '#9ca3af',
  },
  pendingIcon: {
    color: '#f59e0b',
  },
  appRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '18px',
    marginTop: '25px',
  },
  appIcon: {
    width: '58px',
    height: '58px',
    objectFit: 'contain',
  },
  appName: {
    fontWeight: 700,
    fontSize: '20px',
    color: '#111827',
  },
  appDesc: {
    color: '#6b7280',
    fontSize: '14px',
    marginTop: '6px',
  },
  topIcon: {
    position: 'absolute',
    top: 16,
    right: 16,
    fontSize: 28,
  },
  approvedIcon: {
    color: '#22c55e',
  },
  dropdown: {
    position: 'absolute',
    zIndex: 1,
    top: '253px',
    right: '23px',
    width: 270,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    boxShadow: '0px 6px 6px rgba(0, 0, 0, 0.26), 0px 10px 20px rgba(0, 0, 0, 0.19)',
    borderRadius: 4,
  },
  selectActions: {
    width: 160,
    height: '100%',
    marginLeft: theme.spacing(2),
    backgroundColor: '#ffb400',
    borderColor: 'transparent',
    borderRadius: 4,
    color: '#fff',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#e4a610',
    },
    '& > div': {
      padding: theme.spacing(0, 1),
    },
    '& > fieldset': {
      borderColor: 'transparent',
    },
  },
  selectItem: {
    padding: theme.spacing(1, 1.2),
    '& svg': {
      marginRight: theme.spacing(1.2),
    },
    '& img': {
      marginRight: theme.spacing(1.2),
    },
  },
  tabsPanel: {
    width: '100%',
    // overflowX: 'auto',
  },
  tabsPaper: {
    width: '100%',
    boxShadow: theme.shadows[0],
    backgroundColor: 'transparent',
    '& [class*="MuiBox-root"]': {
      padding: theme.spacing(2, 0, 0, 0),
    },
  },
  tabsContainer: {
    overflowX: 'auto', // ✅ Scroll allow karega
    whiteSpace: 'nowrap', // ✅ Tabs wrap hone ki jagah scroll hoga
    width: '100%',
    display: 'flex',
  },
  tabs: {
    width: 'max-content',
    minWidth: '100%',
    border: '1px solid white',
    borderRadius: '4px 0px 0px 4px',
    background: 'white',
    '& .MuiTabs-indicator': {
      backgroundColor: 'orange',
      height: 3,
    },
    '& .MuiTab-root.Mui-selected': {
      color: 'white',
      backgroundColor: '#5081FF',
    },
    '& .MuiTab-root': {
      padding: '16px 24px',
    },
  },
}));
